<template>
  <div class="content">
    <grc-types-item-small :types="[types[0], types[1]]" />
    <grc-types-item-big :types="[types[2]]" />
  </div>
</template>

<script>
import GrcTypesItemSmall from "@/components/main/GRCTypes/modules/GRCTypesItemSmall.vue";
import GrcTypesItemBig from "@/components/main/GRCTypes/modules/GRCTypesItemBig.vue";

export default {
  name: "grc-types-content",
  components: { GrcTypesItemBig, GrcTypesItemSmall },
  props: {
    types: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  column-gap: 20px;
  row-gap: 24px;
  margin-bottom: 40px;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    overflow: scroll;
    flex-wrap: nowrap;
  }

  @media (max-width: 1360px) {
    column-gap: 24px;
  }
}
</style>
